export const updateSaleReturnList = (state, payload) => {
  state.saleReturnList = payload
}

export const fetchSaleReturnInfo = (state, payload) => {
  state.saleReturnInfo = payload
}

export const fetchUnClosedSaleReturnCount = (state, payload) => {
  state.unClosedSaleReturnCount = payload
}

export const fetchUnPaidSaleReturnCount = (state, payload) => {
  state.unPaidSaleReturnCount = payload
}

export const fetchUnClosedReportSaleReturnCount = (state, payload) => {
  state.unClosedReportSaleReturnCount = payload
}

export const fetchUnPaidReportSaleReturnCount = (state, payload) => {
  state.unPaidReportSaleReturnCount = payload
}
